/**
 * WordPress dependencies
 */

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import { default as InspectorInterface } from '../../interface/Inspector/index.js';
import './inspector/tabs';

const Inspector = ( props ) => {
	return <InspectorInterface hookPrefix="container" { ...props } />;
};

export default Inspector;

// addFilter( 'gutenify-block-container-inspector-controls', 'gutenify/blocks/container/inspector-advance-controls/margin-padding', ( content, props ) => {
// 	const { attributes, setAttributes } = props;
// 	const { stretchContainer, maxWidth } = attributes;
// 	const updateStyle = ( data ) => {
// 		updateBlockStyle( data, props );
// 	};
// 	return [ ...content, <Fragment key="gutenify-block-container-inspector-controls-default">
// 		<PanelBody
// 			/* translators: block settings */
// 			title={ __( 'Layout options' ) }
// 		>
// 			{ ! stretchContainer && <UnitControl
// 				label={ __( 'Max width' ) }
// 				help={ __( 'Set max width for the container' ) }
// 				value={ maxWidth }
// 				onChange={ ( value ) => {
// 					const data = { maxWidth: value };
// 					setAttributes( data );
// 					updateStyle( data );
// 				} }
// 			/> }
// 		</PanelBody>
// 	</Fragment> ];
// } );
